import React, { useEffect, useState, useCallback } from 'react'
import { Hidden, Drawer, Divider, Box, Toolbar, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useObserver } from 'mobx-react-lite'
import { AddRounded, PowerSettingsNewRounded } from '@material-ui/icons'
import lodash from 'lodash'

import logo from '../../test-logo.png'
import CustomList from '../Custom/CustomList'
import { firebaseFetchAllDealers } from '../../firebase/dealer'
import { navigate } from '@reach/router'

export default function TempSideBar(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { handleDrawerToggle, mobileOpen, userProfile } = props

  /**
  |--------------------------------------------------
  | States
  |--------------------------------------------------
  */
  const [dealers, setDealers] = useState([])

  /**
  |--------------------------------------------------
  | Fetch Dealers
  |--------------------------------------------------
  */
  const fetchDealers = useCallback(async () => {
    try {
      const dealers = await firebaseFetchAllDealers()
      let dealersForUser = lodash.map(dealers, (d, key) => ({ ...d, id: key }))
      if (userProfile.role !== 'superadmin') {
        dealersForUser = lodash.filter(dealersForUser, d => d.id === userProfile.dealer)
      }
      setDealers(dealersForUser)
    } catch (error) {
      console.error(error)
    }
  }, [userProfile])

  useEffect(() => {
    fetchDealers()
  }, [fetchDealers])

  /**
  |--------------------------------------------------
  | Styles hooks
  |--------------------------------------------------
  */
  const classes = useStyles()

  /**
  |--------------------------------------------------
  | Dealer to List's data
  |--------------------------------------------------
  */
  function dealerList() {
    const dealerList = lodash.map(dealers, item => ({
      name: item.name,
      label: item.name,
      href: `/${item.id}`
    }))

    if (userProfile.role === 'superadmin') {
      dealerList.push({
        label: (
          <Grid container alignItems="center">
            <Box mr={2}>
              <AddRounded />
            </Box>
            <Typography variant="subtitle1">Create new dealer</Typography>
          </Grid>
        ),
        href: `/create-dealer`
      })
    }

    return dealerList
  }

  /**
  |--------------------------------------------------
  | Drawer
  |--------------------------------------------------
  */
  const drawer = (
    <div>
      <Toolbar>
        <Grid container>
          <Grid item xs>
            <Box>
              <img
                src={logo}
                alt="logo"
                style={{ width: '100%', objectFit: 'cover', objectPosition: 'center' }}
              />
            </Box>
          </Grid>
        </Grid>
      </Toolbar>
      <Divider />
      <CustomList data={dealerList()} />
      <Grid container alignItems="center" style={{ position: 'absolute', bottom: '10px', width: '100%' }} >
        <button onClick={() => navigate(`/signout`)} style={{ width: '100%' }}>
          <Box color="white" px={2} py={2} width="100%" display={{ xs: 'flex', sm: 'none' }} >
            <Grid container alignItems="center">
              <Box mr={1}>
                <PowerSettingsNewRounded />
              </Box>
              <Typography variant="subtitle2">Sign out</Typography>
            </Grid>
          </Box>
        </button>
      </Grid>
    </div>
  )

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return useObserver(() => (
    <nav className={classes.drawer} aria-label="mailbox folders">
      <Hidden xsDown implementation="css">
        <Drawer
          classes={{
            paper: classes.drawerPaper
          }}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
        >
          {drawer}
        </Drawer>
      </Hidden>
    </nav>
  ))
}

/**
|--------------------------------------------------
| Custom Styles
|--------------------------------------------------
*/
const drawerWidth = 240

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  }
}))
